// Default map view
const DEFAULT_CENTER = [39.8283, -98.5795];
const DEFAULT_ZOOM = 4;

// Initialize map centered on USA
const map = L.map('map', {
    center: DEFAULT_CENTER,
    zoom: DEFAULT_ZOOM,
    minZoom: 3,
    maxZoom: 18,
    zoomControl: true
});

// Add tile layer (using CartoDB Positron for a cleaner look)
L.tileLayer('https://basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png?key=cb1_3nrx_1_026b9d9b02ac6fd704f27cef', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
    subdomains: 'abcd',
    maxZoom: 20
}).addTo(map);

// Add reset zoom button to the zoom control
setTimeout(() => {
    const zoomControl = document.querySelector('.leaflet-control-zoom');
    if (zoomControl) {
        const resetButton = document.createElement('a');
        resetButton.className = 'leaflet-control-reset-zoom';
        resetButton.href = '#';
        resetButton.title = 'Reset to full map view';
        resetButton.setAttribute('role', 'button');
        resetButton.setAttribute('aria-label', 'Reset zoom');
        resetButton.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
            <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
            <path d="M3 3v5h5"/>
        </svg>`;

        resetButton.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            map.setView(DEFAULT_CENTER, DEFAULT_ZOOM);
        });

        zoomControl.appendChild(resetButton);
    }
}, 100);

// Create marker cluster group
const markers = L.markerClusterGroup({
    chunkedLoading: true,
    maxClusterRadius: 50,
    spiderfyOnMaxZoom: true,
    showCoverageOnHover: false,
    zoomToBoundsOnClick: true,
    iconCreateFunction: function(cluster) {
        const count = cluster.getChildCount();
        let size = 'small';
        if (count >= 10) size = 'medium';
        if (count >= 50) size = 'large';

        return L.divIcon({
            html: `<div>${count}</div>`,
            className: `marker-cluster marker-cluster-${size}`,
            iconSize: L.point(40, 40)
        });
    }
});

// Custom icon for shops
function createShopIcon(type = 'shop') {
    const isShop = type === 'shop';
    const bgColor = isShop ? '#093351' : '#8B6914';
    const iconSvg = isShop
        ? `<svg viewBox="0 0 24 24" fill="white" width="18" height="18"><path d="M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm7 17H5V8h14v12z"/></svg>`
        : `<svg viewBox="0 0 24 24" fill="white" width="18" height="18"><path d="M2 21h18v-2H2v2zm16-8c1.66 0 3-1.34 3-3V5h-3V3H2v7c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-2h2v2c0 .55-.45 1-1 1v2c1.66 0 3-1.34 3-3zM4 10V5h10v5c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2z"/></svg>`;

    return L.divIcon({
        className: 'custom-div-icon',
        html: `
            <div style="
                background: ${bgColor};
                width: 36px;
                height: 36px;
                border-radius: 50% 50% 50% 0;
                transform: rotate(-45deg);
                display: flex;
                align-items: center;
                justify-content: center;
                box-shadow: 3px 3px 0 rgba(0, 0, 0, 0.2);
                border: 2px solid #FFFDF8;
            ">
                <div style="transform: rotate(45deg);">${iconSvg}</div>
            </div>
        `,
        iconSize: [36, 36],
        iconAnchor: [18, 36],
        popupAnchor: [0, -36]
    });
}

// Store all location data
let allLocations = [];
let locationMarkers = new Map();

// Initialize locations
function initializeLocations() {
    if (typeof LOCATIONS === 'undefined' || !Array.isArray(LOCATIONS)) {
        console.error('LOCATIONS data not found');
        return;
    }

    allLocations = LOCATIONS;

    // Add markers for each location
    allLocations.forEach((location, index) => {
        if (!location.lat || !location.lng) return;

        const marker = L.marker([location.lat, location.lng], {
            icon: createShopIcon(location.type || 'shop')
        });

        // Create popup content
        const popupContent = `
            <div class="popup-content">
                <h3>${escapeHtml(location.name)}</h3>
                <p class="popup-address">${escapeHtml(location.address)}</p>
                <button class="popup-btn" onclick="openModal(${index})">View Details</button>
            </div>
        `;

        marker.bindPopup(popupContent);
        marker.locationIndex = index;
        markers.addLayer(marker);
        locationMarkers.set(index, marker);
    });

    map.addLayer(markers);

    // Update stats
    updateStats();
    updateVisibleCount();

    // Add map move listener to update visible count
    map.on('moveend', updateVisibleCount);
}

// Update stats display
function updateStats() {
    const locationCount = document.getElementById('location-count');
    const stateCount = document.getElementById('state-count');

    locationCount.textContent = allLocations.length;

    // Count unique states
    const states = new Set(allLocations.map(loc => loc.state).filter(Boolean));
    stateCount.textContent = states.size;
}

// Update visible location count
function updateVisibleCount() {
    const bounds = map.getBounds();
    let visibleCount = 0;

    allLocations.forEach(location => {
        if (location.lat && location.lng) {
            const latLng = L.latLng(location.lat, location.lng);
            if (bounds.contains(latLng)) {
                visibleCount++;
            }
        }
    });

    document.getElementById('visible-number').textContent = visibleCount;
}

// Search functionality
const searchInput = document.getElementById('search-input');
const searchResults = document.getElementById('search-results');
const clearBtn = document.getElementById('clear-search');

let searchTimeout;

searchInput.addEventListener('input', (e) => {
    const query = e.target.value.trim().toLowerCase();

    clearTimeout(searchTimeout);
    clearBtn.style.display = query ? 'flex' : 'none';

    if (query.length < 2) {
        searchResults.classList.remove('active');
        return;
    }

    searchTimeout = setTimeout(() => {
        performSearch(query);
    }, 200);
});

searchInput.addEventListener('focus', () => {
    if (searchInput.value.length >= 2) {
        performSearch(searchInput.value.trim().toLowerCase());
    }
});

clearBtn.addEventListener('click', () => {
    searchInput.value = '';
    searchResults.classList.remove('active');
    clearBtn.style.display = 'none';
    searchInput.focus();
});

// Close search results when clicking outside
document.addEventListener('click', (e) => {
    if (!e.target.closest('.search-container')) {
        searchResults.classList.remove('active');
    }
});

// State name to abbreviation mapping for search
const STATE_ABBREVS = {
    'alabama':'AL','alaska':'AK','arizona':'AZ','arkansas':'AR','california':'CA',
    'colorado':'CO','connecticut':'CT','delaware':'DE','florida':'FL','georgia':'GA',
    'hawaii':'HI','idaho':'ID','illinois':'IL','indiana':'IN','iowa':'IA','kansas':'KS',
    'kentucky':'KY','louisiana':'LA','maine':'ME','maryland':'MD','massachusetts':'MA',
    'michigan':'MI','minnesota':'MN','mississippi':'MS','missouri':'MO','montana':'MT',
    'nebraska':'NE','nevada':'NV','new hampshire':'NH','new jersey':'NJ','new mexico':'NM',
    'new york':'NY','north carolina':'NC','north dakota':'ND','ohio':'OH','oklahoma':'OK',
    'oregon':'OR','pennsylvania':'PA','rhode island':'RI','south carolina':'SC',
    'south dakota':'SD','tennessee':'TN','texas':'TX','utah':'UT','vermont':'VT',
    'virginia':'VA','washington':'WA','west virginia':'WV','wisconsin':'WI','wyoming':'WY'
};

function performSearch(query) {
    // Check if the query matches a state name, and get the abbreviation
    const matchedStateAbbrev = STATE_ABBREVS[query];

    const results = allLocations
        .map((location, index) => ({ ...location, index }))
        .filter(location => {
            const searchStr = `${location.name} ${location.city} ${location.state} ${location.address}`.toLowerCase();
            if (searchStr.includes(query)) return true;
            // Also match if query is a state name and location is in that state
            if (matchedStateAbbrev && location.state === matchedStateAbbrev) return true;
            return false;
        })
        .slice(0, 50);

    if (results.length === 0) {
        searchResults.innerHTML = '<div class="search-no-results">No locations found</div>';
    } else {
        searchResults.innerHTML = results.map(location => `
            <div class="search-result-item" data-index="${location.index}">
                <div class="search-result-icon">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                        <path d="M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm7 17H5V8h14v12z"/>
                    </svg>
                </div>
                <div class="search-result-info">
                    <div class="search-result-name">${escapeHtml(location.name)}</div>
                    <div class="search-result-address">${escapeHtml(location.city)}, ${escapeHtml(location.state)}</div>
                </div>
            </div>
        `).join('');

        // Add click handlers
        searchResults.querySelectorAll('.search-result-item').forEach(item => {
            item.addEventListener('click', () => {
                const index = parseInt(item.dataset.index);
                const location = allLocations[index];

                if (location.lat && location.lng) {
                    map.setView([location.lat, location.lng], 15);

                    const marker = locationMarkers.get(index);
                    if (marker) {
                        markers.zoomToShowLayer(marker, () => {
                            marker.openPopup();
                        });
                    }
                }

                searchResults.classList.remove('active');
                searchInput.value = location.name;
            });
        });
    }

    searchResults.classList.add('active');
}

// Modal functionality
const modal = document.getElementById('shop-modal');
const modalClose = document.getElementById('modal-close');

function openModal(index) {
    const location = allLocations[index];
    if (!location) return;

    // Update modal content
    document.getElementById('modal-title').textContent = location.name;
    document.getElementById('modal-address').textContent = location.address;

    // Phone
    const phoneSection = document.getElementById('phone-section');
    const modalPhone = document.getElementById('modal-phone');
    const modalCall = document.getElementById('modal-call');

    if (location.phone) {
        phoneSection.style.display = 'flex';
        modalPhone.textContent = formatPhone(location.phone);
        modalCall.href = `tel:${location.phone}`;
        modalCall.style.display = 'inline-flex';
    } else {
        phoneSection.style.display = 'none';
        modalCall.style.display = 'none';
    }

    // Directions link
    const directionsBtn = document.getElementById('modal-directions');
    const encodedAddress = encodeURIComponent(location.address);
    directionsBtn.href = `https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`;

    // Reset gallery and rating
    const gallery = document.getElementById('modal-gallery');
    gallery.innerHTML = `
        <div class="gallery-placeholder">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <rect x="3" y="3" width="18" height="18" rx="2"/>
                <circle cx="8.5" cy="8.5" r="1.5"/>
                <path d="M21 15l-5-5L5 21"/>
            </svg>
            <span>Loading photos...</span>
        </div>
    `;

    const ratingDiv = document.getElementById('modal-rating');
    ratingDiv.innerHTML = '';

    document.getElementById('hours-section').style.display = 'none';
    document.getElementById('modal-hours-status').innerHTML = '';
    document.getElementById('modal-hours').innerHTML = '';
    document.querySelector('.hours-accordion').classList.remove('open');
    document.getElementById('modal-website').style.display = 'none';

    // Show modal
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';

    // Fetch Google Places data
    fetchPlaceDetails(location);
}

function closeModal() {
    modal.classList.remove('active');
    document.body.style.overflow = '';
}

modalClose.addEventListener('click', closeModal);

modal.addEventListener('click', (e) => {
    if (e.target === modal) {
        closeModal();
    }
});

document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
        closeModal();
    }
});

// Hours accordion toggle
document.getElementById('hours-toggle').addEventListener('click', () => {
    document.querySelector('.hours-accordion').classList.toggle('open');
});

// Google Places API integration
let placesService = null;
let placesReady = false;

// Called when Google Maps API loads
window.initGooglePlaces = function() {
    if (window.GOOGLE_PLACES_API_KEY) {
        // Create a dummy div for PlacesService (required by the API)
        const placesDiv = document.createElement('div');
        placesService = new google.maps.places.PlacesService(placesDiv);
        placesReady = true;
        console.log('Google Places API initialized');
    }
};

function fetchPlaceDetails(location) {
    const gallery = document.getElementById('modal-gallery');

    // Check if API key is configured
    if (!window.GOOGLE_PLACES_API_KEY) {
        gallery.innerHTML = `
            <div class="gallery-placeholder">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <rect x="3" y="3" width="18" height="18" rx="2"/>
                    <circle cx="8.5" cy="8.5" r="1.5"/>
                    <path d="M21 15l-5-5L5 21"/>
                </svg>
                <span>Add Google API key for photos & ratings</span>
            </div>
        `;
        return;
    }

    // Wait for Places API to be ready
    if (!placesReady) {
        gallery.innerHTML = `
            <div class="gallery-placeholder">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <rect x="3" y="3" width="18" height="18" rx="2"/>
                    <circle cx="8.5" cy="8.5" r="1.5"/>
                    <path d="M21 15l-5-5L5 21"/>
                </svg>
                <span>Loading Google Places...</span>
            </div>
        `;
        // Retry after a short delay
        setTimeout(() => fetchPlaceDetails(location), 500);
        return;
    }

    // Search for the place using text search
    const searchQuery = `${location.name} ${location.city} ${location.state}`;

    const request = {
        query: searchQuery,
        fields: ['place_id', 'name', 'geometry']
    };

    placesService.findPlaceFromQuery(request, (results, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && results && results.length > 0) {
            // Get detailed place info
            const detailsRequest = {
                placeId: results[0].place_id,
                fields: [
                    'name',
                    'rating',
                    'user_ratings_total',
                    'photos',
                    'opening_hours',
                    'website',
                    'formatted_phone_number',
                    'url'
                ]
            };

            placesService.getDetails(detailsRequest, (place, detailsStatus) => {
                if (detailsStatus === google.maps.places.PlacesServiceStatus.OK && place) {
                    updateModalWithPlaceDetails(place);
                } else {
                    showNoPlaceFound();
                }
            });
        } else {
            showNoPlaceFound();
        }
    });
}

function showNoPlaceFound() {
    const gallery = document.getElementById('modal-gallery');
    gallery.innerHTML = `
        <div class="gallery-placeholder">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <rect x="3" y="3" width="18" height="18" rx="2"/>
                <circle cx="8.5" cy="8.5" r="1.5"/>
                <path d="M21 15l-5-5L5 21"/>
            </svg>
            <span>No photos available</span>
        </div>
    `;
}

function updateModalWithPlaceDetails(place) {
    // Update rating
    if (place.rating) {
        const ratingDiv = document.getElementById('modal-rating');
        const fullStars = Math.floor(place.rating);
        const hasHalfStar = place.rating % 1 >= 0.5;

        let starsHtml = '<div class="stars">';
        for (let i = 0; i < 5; i++) {
            if (i < fullStars) {
                starsHtml += '<svg viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
            } else if (i === fullStars && hasHalfStar) {
                starsHtml += '<svg viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="url(#half)"/><defs><linearGradient id="half"><stop offset="50%" stop-color="#FBBF24"/><stop offset="50%" stop-color="#E5E7EB"/></linearGradient></defs></svg>';
            } else {
                starsHtml += '<svg viewBox="0 0 24 24" class="star-empty"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
            }
        }
        starsHtml += '</div>';

        ratingDiv.innerHTML = `
            ${starsHtml}
            <span class="rating-number">${place.rating.toFixed(1)}</span>
            ${place.user_ratings_total ? `<span class="review-count">(${place.user_ratings_total.toLocaleString()} reviews)</span>` : ''}
        `;
    }

    // Update photos
    if (place.photos && place.photos.length > 0) {
        const gallery = document.getElementById('modal-gallery');
        const photosHtml = place.photos.slice(0, 5).map(photo => {
            const photoUrl = photo.getUrl({ maxWidth: 400, maxHeight: 300 });
            return `<img class="gallery-image" src="${photoUrl}" alt="Shop photo" loading="lazy">`;
        }).join('');
        gallery.innerHTML = `<div class="gallery-images">${photosHtml}</div>`;
    } else {
        showNoPlaceFound();
    }

    // Update hours
    if (place.opening_hours && place.opening_hours.weekday_text) {
        const hoursSection = document.getElementById('hours-section');
        const hoursDiv = document.getElementById('modal-hours');
        const hoursStatus = document.getElementById('modal-hours-status');
        hoursSection.style.display = 'flex';

        // Show open/closed status in the accordion header
        if (place.opening_hours.isOpen !== undefined) {
            const isOpen = place.opening_hours.isOpen();
            hoursStatus.innerHTML = `<span class="open-status ${isOpen ? 'open' : 'closed'}">${isOpen ? 'Open Now' : 'Closed'}</span>`;
        }

        // Highlight current day
        const today = new Date().getDay();
        const dayIndex = today === 0 ? 6 : today - 1; // Convert to Monday=0 format

        hoursDiv.innerHTML = place.opening_hours.weekday_text.map((day, idx) => {
            const isToday = idx === dayIndex;
            return `<div class="${isToday ? 'hours-today' : ''}">${day}</div>`;
        }).join('');
    }

    // Update website
    if (place.website) {
        const websiteBtn = document.getElementById('modal-website');
        websiteBtn.href = place.website;
        websiteBtn.style.display = 'inline-flex';
    }

    // Update phone if Google has a different one
    if (place.formatted_phone_number) {
        const modalPhone = document.getElementById('modal-phone');
        const phoneSection = document.getElementById('phone-section');
        const modalCall = document.getElementById('modal-call');

        phoneSection.style.display = 'flex';
        modalPhone.textContent = place.formatted_phone_number;
        modalCall.href = `tel:${place.formatted_phone_number.replace(/\D/g, '')}`;
        modalCall.style.display = 'inline-flex';
    }
}

// Utility functions
function escapeHtml(text) {
    if (!text) return '';
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}

function formatPhone(phone) {
    if (!phone) return '';
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length === 10) {
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    } else if (cleaned.length === 11 && cleaned[0] === '1') {
        return `(${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
    }
    return phone;
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initializeLocations);

// Make openModal globally accessible
window.openModal = openModal;
